export default {
  docTitle: "Authing open platform",
  banner: {
    item1: {
      title: "Authing",
      title2: "open platform",
      subtitle:
        "The Authing open platform provides rich open interface capabilities and SDK kits covering all major languages. You can call and learn how to use the API interface through the API Explorer provided by us, or you can quickly get started through the project instance.",
      subtitleSmall:
        "The Authing open platform provides rich open interface capabilities and SDK kits covering all major languages.",
      btnName: "Developer documentation",
      linkName: "API Explorer",
    },
  },
  api: {
    title: "Rich open capabilities support efficient integration",
    desc:
      "Each function of Authing provides an enterprise-level interface to help customers complete in-depth integration with Authing.",
    tabs: {
      tab1: {
        label: "Management API",
      },
      tab2: {
        label: "Certification API",
      },
    },
    content: {
      manageUsers: "Manage users",
      manageOrg: "Management organization",
      manageRole: "Management role",
      manageUserGroups: "Manage user groups",
      manageCustomField: "Manage Custom Fields",
      manageResourcesAuth: "Manage resources and permissions",
      manageDataResourcesAuth: "Manage data resources and permissions",
      manageApps: "Management application",
      manageIdentity: "Manage identity sources",
      manageSafeConfig: "Manage Security Configuration",
      manageMessage: "Manage Message Service",
      manageSyncCenter: "Manage Sync Center",
      managePipeline: "Manage PIPELINE",
      manageWebhook: "Manage WEBHOOK",
      manageLog: "Get audit log",
      manageCost: "Manage metering and billing",
      messageAuth: "Message service",
      wechatAuth: "WeChat related interface",
      login: "Sign in",
      manageToken: "Manage TOKEN",
      logout: "Log out",
      register: "Register",
      userInfo: "User information",
      bind: "Account binding",
      mfa: "MFA Element Management",
      userAbouts: "User related resources",
    },
  },
  manual: {
    title: "Scenario-based user manual helps to quickly integrate identity",
    desc:
      "Based on different identity-based scenarios, the corresponding Authing user manual is provided to help customers quickly complete the construction of cloud native identity system.",
    b2e: {
      title: "B2E Administrator User Manual",
      desc:
        "Learn how to use Authing to manage identity for enterprise employees",
    },
    b2c: {
      title: "B2C Administrator User Manual",
      desc:
        "Learn how to use Authing to provide better identity authentication experience for C-end users",
    },
    b2b: {
      title: "B2B Administrator User Manual",
      desc:
        "Learn how to use Authing to provide better identity authentication experience for B-end users",
    },
  },
  playground: {
    title: "Project instance",
    tab: {
      b2c: "B2C",
      b2e: "B2E",
      b2b: "B2B",
      m2m: "M2M",
    },
    background: "Project background",
    download: "Coming soon",
    try: "Experience",
    check: "View",
  },
  application: {
    title: "Application network",
  },
  join: {
    title: "Want to join the Authing cooperation network?",
    desc:
      "You can add the application to the Authing cooperation network to enable thousands of customers to quickly integrate and access",
    btnText: "Learn more",
  },
};
